export default [
    {
        name: "thread",
        path: "client/chat/thread",
        method: "get",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {}
    },
    {
        name: "messages",
        path: "client/chat/messages?limit=:limit&before=:before&after=:after",
        method: "get",
        loading: false,
        alert: true,
        defaultHeader: {},
        defaultBody: {}
    },
    {
        name: "send",
        path: "client/chat/messages",
        method: "post",
        loading: false,
        alert: true,
        defaultHeader: {},
        defaultBody: {}
    },
    {
        name: "upload",
        path: "client/chat/upload",
        method: "post",
        loading: false,
        alert: true,
        defaultHeader: {},
        defaultBody: {}
    },
    {
        // Returns a presigned S3 URL for a given uploaded file so browser can render it without auth headers
        name: "signedUrl",
        path: "client/chat/files/:fileId/signed-url?name=:name",
        method: "get",
        loading: false,
        alert: false,
        defaultHeader: {},
        defaultBody: {}
    },
]

